export default {
    all: { method: 'GET', url: 'periodicidade/all' },
    active: { method: 'GET', url: 'periodicidade/active' },
    get: { method: 'GET', url: 'periodicidade/get{/id}' },
    create: { method: 'POST', url: 'periodicidade' },
    update: { method: 'PUT', url: 'periodicidade' },
    inactive: { method: 'DELETE', url: 'periodicidade{/id}' },
};